export default __webpack_public_path__ + "static/media/member-at.a804c8e4.png";